import {
  Component,
  OnInit,
  Injector,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { BaseEntityComponent, BnLoadingService, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { CobrancaService } from "./cobranca.service";
import { FileUtilsService } from "src/app/shared/file-utils.service";
import { Cobranca, TIPO_COBRANCA } from "src/app/model/cobranca.model";
import { BnConfirmDirective } from "@bndes/bndes-ux4/bn-confirm";
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";
import { OcorrenciaValidacaoVO } from "src/app/shared/ocorrencia-validacao.vo";
import { PermissaoService } from "src/app/shared/permissao.service";
import { ROLE_GESTOR_ENVIO } from "src/app/constantes/permissao.constants";
import { RetornoMensagemSimplesDTO } from "src/app/model/questionario.model";
import { Observable } from "rxjs";

@Component({
  selector: "app-cobranca-detalhe",
  templateUrl: "./cobranca-detalhe.component.html",
  styleUrls: ["./cobranca-detalhe.component.scss"],
  standalone: false
})
export class CobrancaDetalheComponent
  extends BaseEntityComponent<Cobranca>
  implements OnInit
{
  private idCobranca: number;
  public cobranca: Cobranca;
  private labelTipoCobranca: string;
  public motivoReemissao: string;
  public ocorrencias: OcorrenciaValidacaoVO[] = [];
  public podeReemitirCobranca = false;

  @ViewChild("mensagemConfirmacaoReemissaoCobranca")
  mensagemConfirmacaoReemissaoCobranca: TemplateRef<any>;
  @ViewChild("botoesConfirmacaoReeemissaoCobranca")
  botoesConfirmacaoReeemissaoCobranca: TemplateRef<any>;

  constructor(
    protected injector: Injector,
    protected service: CobrancaService,
    private fileUtils: FileUtilsService,
    private modalService: BnModalMessageService,
    private loadingService: BnLoadingService,
    private permissaoService: PermissaoService
  ) {
    super(service);
  }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.idCobranca = params["id"];
      this.service.getCobranca(this.idCobranca).subscribe((resp) => {
        this.cobranca = resp;

        this.cobranca.dataEmissaoDaFicha = this.ajustaCampoDate(
          this.cobranca.dataEmissaoDaFicha
        );
        this.cobranca.dataVencimentoDaFicha = this.ajustaCampoDate(
          this.cobranca.dataVencimentoDaFicha
        );
        this.cobranca.dataPagamentoDaFicha = this.ajustaCampoDate(
          this.cobranca.dataPagamentoDaFicha
        );
        this.labelTipoCobranca = TIPO_COBRANCA.filter((tipo) =>
          tipo.codigo.includes(this.cobranca.tipoCobranca)
        )[0].labelCompleto;
      });
    });

    this.permissaoService
      .getPermissoesUsuarioAutenticado()
      .subscribe((resp: any) => {
        this.podeReemitirCobranca = resp && resp[ROLE_GESTOR_ENVIO];
      });
  }

  exportarBoleto(cobranca: Cobranca) {
    this.service.getBoleto(cobranca.id).subscribe((conteudoBoleto) => {
      this.fileUtils.exportarArquivo(
        "Boleto_" + cobranca.codigoCobranca + ".pdf",
        conteudoBoleto,
        FileUtilsService.APPLICATION_PDF
      );
    });
  }

  exportarExtrato(cobranca: Cobranca) {
    this.service.getExtrato(cobranca.id).subscribe((conteudoExtrato) => {
      this.fileUtils.exportarArquivo(
        "Extrato_" + cobranca.codigoCobranca + ".txt",
        conteudoExtrato,
        FileUtilsService.TEXT_PLAIN
      );
    });
  }

  exportarAnexo(cobranca: Cobranca) {
    this.service.getAnexo(cobranca.id).subscribe((conteudoAnexo) => {
      this.fileUtils.exportarArquivo(
        "Anexo_" + cobranca.codigoCobranca + ".txt",
        conteudoAnexo,
        FileUtilsService.TEXT_PLAIN
      );
    });
  }

  voltar() {
    this.router.navigate(["/cobrancas/pesquisa"]);
  }

  abrirModalConfirmacaoReemissaoCobranca() {
    this.modalService.abrir(
      "Reemissão de cobrança",
      null,
      "md",
      this.mensagemConfirmacaoReemissaoCobranca,
      this.botoesConfirmacaoReeemissaoCobranca
    );
  }

  reemitirCobranca() {
    this.abreModalConfirmacao("As liberações e/ou aditivos associados a esta cobrança serão transitados para o estado 'Aguardando emissão de cobrança' e serão contemplados na próxima emissão noturna da cobrança. Por isso, o cancelamento de operações ou aditivos, se necessário, deverá ser realizado até o fim do dia. Deseja confirmar? ").then((resp) => {
      if (resp === true) {
        this.loadingService.bloqueiaTela();
        this.service
          .reemitirCobranca(this.idCobranca, this.motivoReemissao)
          .subscribe(
            (msg: RetornoMensagemSimplesDTO) => {
              this.messageService.addMessage({
                title: "Sucesso",
                type: "CRUD_OPERATION",
                level: messageLevel.SUCCESS,
                message: msg.mensagem,
              });

              // recarrega a cobranca
              this.service.getCobranca(this.idCobranca).subscribe((resp) => {
                this.cobranca = resp;
              });

              this.loadingService.liberaTela();
            },
            (error) => {
              this.loadingService.liberaTela();
            }
          );
      }
    });
  }

  async abreModalConfirmacao(mensagem: string): Promise<boolean> {
    const titulo = 'Confirmação';

    try {
        const resultadoConfimacao = await this.modalService.abrirConfirm(titulo, mensagem).result;
        return resultadoConfimacao.value === 'ok';
    } catch (e) {
        return false;
    }
  }

  cancelarReemissao() {
    this.modalService.dismiss("abortou a reemissao de cobranca");
  }

  ajustaCampoDate(data: any) {
    if (typeof data === "string") {
      if (data.length == 10) {
        data += " 00:00:00";
      }
      return new Date(data);
    }

    return data;
  }
}
